import { render, staticRenderFns } from "./MainLedgerPayPrint.vue?vue&type=template&id=020945be&scoped=true"
import script from "./MainLedgerPayPrint.vue?vue&type=script&lang=js"
export * from "./MainLedgerPayPrint.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPayPrint.vue?vue&type=style&index=0&id=020945be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020945be",
  null
  
)

export default component.exports